import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "navigator" }
const _hoisted_3 = { class: "router-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "logo-n-site-name" }, [
        _createElementVNode("img", {
          alt: "Vue logo",
          src: _imports_0,
          class: "logo"
        }),
        _createElementVNode("h1", { class: "site-name" }, " Backend SaaS ")
      ], -1)),
      _createElementVNode("nav", _hoisted_3, [
        _createVNode(_component_router_link, {
          class: "router-link",
          to: "/"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("Create API")
          ])),
          _: 1
        }),
        _createVNode(_component_router_link, {
          class: "router-link",
          to: "/projects"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("My Projects")
          ])),
          _: 1
        })
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "sign-btn" }, " Sign in / Sign up ", -1))
    ])
  ]))
}